export default "__VITE_PUBLIC_ASSET__c454c6a3__"